import { noop } from "@oefr/utils/react"
import { useMutation } from "@tanstack/react-query"
import { type InputOf } from "@/graphql"
import { useGraphQLClient } from "@/lib/blueprint-auth/client"
import { logger } from "@/lib/logger"
import { SendPmaxSummaryEmailMutation } from "../graphql/sendPmaxSummaryEmail"
import { type SummaryEmailValues } from "../types/summaryEmailValues"
import { useMeterPowerAnalysisWizard } from "../wizard"

export function useSendPmaxSummaryEmail() {
    const { formValues } = useMeterPowerAnalysisWizard()
    const oeGraphQLClient = useGraphQLClient({ target: "oeBackend" })

    const pmaxSummaryEmail = useMutation({
        mutationFn: async (input: InputOf<typeof SendPmaxSummaryEmailMutation>) =>
            await oeGraphQLClient.request(SendPmaxSummaryEmailMutation, { input }),
        onError: noop,
    })

    async function handleSendPmaxSummaryEmail(values: SummaryEmailValues) {
        const { email } = values
        const { pmaxToken } = formValues

        if (!pmaxToken) return false

        try {
            pmaxSummaryEmail.mutate({
                email,
                token: pmaxToken,
                emailConsent: true,
            })
        } catch (error) {
            logger.error({
                error,
                meta: {
                    feature: "meterPowerAnalysis",
                    source: "useSendPmaxSummaryEmail",
                },
            })
        }
    }

    return [handleSendPmaxSummaryEmail, pmaxSummaryEmail] as const
}
